import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { TextField, Box, Loader, Stack, Alert, Text, RadioGroup, RadioItem, Badge } from "braid-design-system";
import { translations as translations$1 } from "../../../.vocab/index.mjs";
import { translations } from "../../../private/components/EveryApplicationEmail/.vocab/index.mjs";
import { loading, hidden } from "./index.css.mjs";
const EveryApplicationEmail = ({
  id,
  onEmailChange,
  emailValue,
  emailErrorMessage
}) => {
  const { t } = useTranslations(translations);
  const handleEmailChange = (event) => {
    var _a;
    onEmailChange((_a = event.target) == null ? void 0 : _a.value);
  };
  return /* @__PURE__ */ jsx(
    TextField,
    {
      id: `${id}-everyApplicationEmail`,
      label: t("Every application emails will be sent to..."),
      onChange: handleEmailChange,
      value: emailValue,
      ...emailErrorMessage && {
        message: emailErrorMessage,
        tone: "critical"
      }
    }
  );
};
var NotificationFrequency = /* @__PURE__ */ ((NotificationFrequency2) => {
  NotificationFrequency2["DAILY"] = "DAILY";
  NotificationFrequency2["WEEKLY"] = "WEEKLY";
  NotificationFrequency2["EVERY_APPLICATION"] = "EVERY_APPLICATION";
  NotificationFrequency2["NEVER"] = "NEVER";
  return NotificationFrequency2;
})(NotificationFrequency || {});
const getNotificationOptionSettings = ({
  messages
}) => [
  {
    helpText: messages["A daily summary..."],
    value: NotificationFrequency.DAILY,
    label: messages["Daily email"],
    frequencyText: messages.Daily,
    promote: true
  },
  {
    helpText: messages["A weekly summary..."],
    value: NotificationFrequency.WEEKLY,
    label: messages["Weekly email"],
    frequencyText: messages.Weekly
  },
  {
    helpText: messages["Every application will be emailed to you"],
    value: NotificationFrequency.EVERY_APPLICATION,
    label: messages["Every application email"],
    frequencyText: messages["Every application"]
  },
  {
    helpText: messages["We will not email you..."],
    value: NotificationFrequency.NEVER,
    label: messages.Never,
    frequencyText: messages.Never
  }
];
const getNotificationOptionSetting = (notificationOptionSettings, value) => {
  const matchedSetting = notificationOptionSettings.find(
    (setting) => setting.value === value
  );
  return matchedSetting ?? null;
};
const translationMessages = (t) => ({
  "Daily email": t("Daily email"),
  Daily: t("Daily"),
  "A daily summary...": t("A daily summary..."),
  "Weekly email": t("Weekly email"),
  Weekly: t("Weekly"),
  "A weekly summary...": t("A weekly summary..."),
  "Every application email": t("Every application email"),
  "Every application": t("Every application"),
  "Every application will be emailed to you": t(
    "Every application will be emailed to you"
  ),
  Never: t("Never"),
  "We will not email you...": t("We will not email you...")
});
const HirerNotificationPreferenceFormPresentation = ({
  frequency,
  everyApplicationEmail = "",
  everyApplicationEmailError = "",
  loading: loading$1 = false,
  onFrequencyChange,
  onEveryApplicationEmailChange,
  id,
  size
}) => {
  const { t } = useTranslations(translations$1);
  const messages = translationMessages(t);
  const notificationOptionSettings = getNotificationOptionSettings({
    messages
  });
  const handleFrequencyChange = (event) => onFrequencyChange(event.currentTarget.value);
  return /* @__PURE__ */ jsxs(Box, { position: "relative", children: [
    loading$1 ? /* @__PURE__ */ jsx(Box, { className: loading, children: /* @__PURE__ */ jsx(Loader, {}) }) : null,
    /* @__PURE__ */ jsx(
      Box,
      {
        className: {
          [hidden]: loading$1
        },
        children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
          /* @__PURE__ */ jsx(Alert, { tone: "caution", children: /* @__PURE__ */ jsx(Text, { children: t(
            "Changing your preferences won’t apply to applications you’ve already received."
          ) }) }),
          /* @__PURE__ */ jsx(
            RadioGroup,
            {
              id,
              label: "",
              size,
              onChange: handleFrequencyChange,
              value: frequency,
              children: notificationOptionSettings.map(
                ({
                  value,
                  label,
                  helpText,
                  promote
                }) => /* @__PURE__ */ jsx(
                  RadioItem,
                  {
                    label,
                    value,
                    description: helpText,
                    badge: promote ? /* @__PURE__ */ jsx(Badge, { tone: "promote", children: t("Recommended") }) : void 0,
                    children: value === NotificationFrequency.EVERY_APPLICATION ? /* @__PURE__ */ jsx(Box, { display: "flex", paddingTop: "xxsmall", children: /* @__PURE__ */ jsx(
                      EveryApplicationEmail,
                      {
                        id: `${id}-every-application-email`,
                        emailErrorMessage: everyApplicationEmailError,
                        onEmailChange: onEveryApplicationEmailChange,
                        emailValue: everyApplicationEmail
                      }
                    ) }) : null
                  },
                  `${id}-${value}`
                )
              )
            }
          )
        ] })
      }
    )
  ] });
};
export {
  HirerNotificationPreferenceFormPresentation,
  NotificationFrequency,
  getNotificationOptionSetting,
  getNotificationOptionSettings,
  translationMessages
};
